import {Component, ElementRef, OnInit} from '@angular/core';
import {finalize} from 'rxjs/operators';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ShoppingPromotionModel} from '../../models/shopping-promotion.model';
import { DOCUMENT } from '@angular/platform-browser';
import {NfModel} from '../../models/nf.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {NgxMaskModule} from 'ngx-mask';
import {PlaceServiceBase} from '@app/core/places.service';
import {ChainService} from '@app/chain/chain.service';
import {DomainService} from '@app/core/domain/domain.service';


@Component({
  selector: 'app-shopping-promotion-nffForm',
  templateUrl: './shopping-promotion-nf-form.component.html',
  styleUrls: ['./shopping-promotion-nf-form.component.scss']
})
export class ShoppingPromotionNfFormComponent {
  promotion: string;
  nfModel: NfModel;
  code = '';
  codeForm: FormGroup;
  modalReference: NgbModalRef;
  modalContent: any;
  shoppingid: string;
  placeService: PlaceServiceBase;
  isShoppingDomain: boolean;

  constructor(private formBuilder: FormBuilder,
              private shoppingService: ShoppingService,
              private chainService: ChainService,
              private domainService: DomainService,
              private modalService: NgbModal,
              private route: ActivatedRoute,
              private router: Router,
              private el: ElementRef) {
    this.isShoppingDomain = domainService.isShoppingDomain();
    this.placeService = this.isShoppingDomain ? shoppingService : chainService;
    this.route.params.subscribe( params => {
      this.promotion = params.promotionId;
      this.shoppingid = params.shoppingId;
    } );

    this.codeForm = this.formBuilder.group({
      code: ['', Validators.required],
    });
  }


   registerNfc(content: any) {
    this.modalContent = content;
    this.placeService.registerNfcPromotion(this.code)
       .pipe(finalize(() => {
       }))
       .subscribe(nfc => {
         if (nfc.id) {
           this.nfModel = nfc;
           this.openNF(this.modalContent);
         } else {
           let message = 'Ocorreu um erro ao recuperar a nota.';
            switch (nfc.status) {
              case 422:
                    message = 'Estabelecimento não habilitado na promoção.';
                    break;
              case 409:
                    message = 'Nota já cadastrada.';
                    break;
              case 411:
                    message = 'Estabelecimento não habilitado na promoção.';
                    break;
              case 423:
                    message = 'Nota não registrada em seu cpf.';
                    break;
              default:
                break;
           }
           alert(message);
         }

       }, error => {
         alert('Ocorreu um erro ao recuperar sua nota.');
         console.log(`Nfc error: ${error}`);
       });
   }

  confirmNfce() {
    this.placeService.confirmNfce(this.nfModel.id)
       .pipe(finalize(() => {
       }))
       .subscribe(status => {
         if (status === 200) {
           this.modalReference.dismiss();
           this.router.navigate(['/shopping/[shoppingId]/promotion/[promotionId]'
             .replace('[shoppingId]', this.shoppingid)
             .replace('[promotionId]', this.promotion)
           ]);

         } else {
           alert('Ocorreu um erro ao aprovar sua nota.');
         }
       }, error => {
         alert('Ocorreu um erro ao aprovar sua nota.');
         console.log(`Nfc error: ${error}`);
       });
   }

  openNF(content: any) {
    this.modalReference = this.modalService.open(content, { windowClass: 'modal-centered modal-md' });
  }


}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-promotion-nf-form/shopping-promotion-nf-form.component.ts